import { RoomManager } from './../../../managers/RoomManager';
import { GameVars } from "../../../GameVars";
import { GameConstants } from "../../../GameConstants";

export class Bot {

    // PRE FLOP HAND VALUATIONS
    private static AK_PAIR_PRE = 100;
    private static AK_CONN_PRE = 90;
    private static QJ_PAIR_PRE = 90;
    // Ten Pair
    private static T_PAIR_PRE = 70;
    // Royal connected
    private static R_CONN_PRE = 50;

    // POST FLOP HAND VALUATIONS
    private static HIGH_STRAIGHT_POST = 120;
    private static FULLHOUSE_POST = 100;
    private static FLUSH_POST = 90;
    private static OVERPAIR_POST = 90;
    private static TOPPAIR_POST = 80;

    // RISK VALUATIONS
    private static STRAIGHT_RISK = 60;
    private static FLUSH_RISK = 60;
    private static FULLHOUSE_RISK = 50;
    private static DRAW_RISK = 20;
    private static PAIR_RISK = 20;
    private static TOPCARD_RISK = 20;
    private static LOWPAIR_RISK = 15;

    public id: string;
    public attributes: Attributes;
    public rivalry: { [key: string]: number; };

    // co-efficients for strategies
    private CONFIDENT = 2;
    private MIDDLING = 1.25;
    private PADDLING = 0.75;

    private CONFIDENT_THRESHOLD = 100;
    private MIDDLING_THRESHOLD = 60;
    private PADDLING_THRESHOLD = 30;
    private RISK_THRESHOLD = 2.5;
    private LUCK_UPPER_THRESHOLD = 10;
    private LUCK_LOWER_THRESHOLD = 0;

    private DRAG_THRESHOLD = 100;

    private SHOVE_THRESHOLD = 300; // How many chips to raise before we think a shove is happening

    private LUCK_MITIGATION = 0.1;
    private RISK_MITIGATION = 0.1;
    private SHOVE_MITIGATION = 0.1;

    private LAST_ANALYSIS: any;
    private ACTIONS: any;
    private bluffs: any;

    private levelRandom1: number;
    private levelRandom2: number;
    private levelRandom3: number;

    private usePlayerCards: boolean;

    public static cardValue(c: any) {

        c = c[0];

        if (c === "T") { return 10; }
        if (c === "J") { return 11; }
        if (c === "Q") { return 12; }
        if (c === "K") { return 13; }
        if (c === "A") { return 14; }

        return +c;
    }

    constructor(id: string) {

        this.id = id;
        this.attributes = GameVars.botsInfo[this.id].attributes;

        this.LAST_ANALYSIS = {};
        this.ACTIONS = {};
        this.bluffs = {};
        this.rivalry = {};

        for (let i = 0; i < GameVars.gameState.players.length; i++) {

            if (GameVars.gameState.players[i].id !== this.id) {
                this.rivalry[GameVars.gameState.players[i].id] = 0;
            }
        }
    }

    public generateInitialValues(): void {

        let val = Math.random() < .5 ? 1 : -1;
        this.levelRandom1 = Math.round((10 - this.attributes.level) * (Math.random() * 5)) * val;
        val = Math.random() < .5 ? 1 : -1;
        this.levelRandom2 = Math.round((10 - this.attributes.level) * (Math.random() * 5)) * val;
        val = Math.random() < .5 ? 1 : -1;
        this.levelRandom3 = Math.round((10 - this.attributes.level) * (Math.random() * 5)) * val;

        if (Math.random() < .25 + ((Math.pow(this.attributes.level, 2) / 100) * .75)) {
            this.usePlayerCards = true;
        } else {
            this.usePlayerCards = false;
        }
    }

    public getBet(game: PokerGameState): { bet: number, bluff: boolean, handScore: number } {

        let values: { bet: number, bluff: boolean, handScore: number };
        let self = this.self(game.players);

        if (game.state === GameConstants.PRE_FLOP) {
            values = this.preFlopStrategy(game);
        } else {
            values = this.postFlopStrategy(game);
        }

        if (!values) {
            values = { bet: 0, bluff: false, handScore: 0 };
        }

        for (let i = 0; i < GameVars.gameState.players.length; i++) {

            let player = GameVars.gameState.players[i];

            if (player.id !== this.id) {
                if (player.wagered === GameVars.gameState.call) {
                    let credibility = RoomManager.getCredibility(player.id);
                    if (values.handScore > 50 && Math.random() > .5 + ((credibility / 100) * .5)) {
                        values = { bet: GameVars.gameState.call, bluff: false, handScore: 0 };
                    }

                    if (Math.random() > .5 + (.5 - (this.rivalry[player.id] / 100) * .5)) {
                        values.bet = GameVars.gameState.call;
                    }
                }
            }
        }

        if (this.usePlayerCards) {
            values.bet = this.decideWithPlayersCards(game, values.bet);
            values.bluff = false;
        }

        values.bet = Math.ceil(values.bet / 5) * 5;

        if (values.bet < GameVars.gameState.call && GameVars.gameState.call < (self.wagered + self.poted / 5)) {
            values.bet = GameVars.gameState.call;
        }

        // si te quedan menos de 5 ciegas grandes van con todo
        if (self.chips < GameVars.gameState.bigBlind * 5) {
            values.bet = self.chips;
        }

        if (values.bet > self.chips) {
            values.bet = self.chips;
        } else if (values.bet < GameVars.gameState.call && values.bet !== self.chips) {
            values.bet = 0;
        }

        // values.bet = self.chips;

        return values;
    }

    public decideWithPlayersCards(game: PokerGameState, currentBet: number): number {

        let self = this.self(game.players);
        let playerHand = Hand.solve(self.cards);

        let hands = [];

        for (let i = 0; i < game.players.length; i++) {
            if (game.players[i].state === GameConstants.ACTIVE) {
                let cards = game.community.concat(game.players[i].cards);
                let hand = Hand.solve(cards);
                hand.id = game.players[i].id;
                hands.push(hand);
            }
        }

        let winners = Hand.winners(hands);

        if (game.state === GameConstants.PRE_FLOP) {
            // let isPlayer = false;
            // for (let i = 0; i < winners.length; i++) {
            //     if (winners[i].id === self.id) {
            //         isPlayer = true;
            //     }
            // }

            // if (!isPlayer) {
            //     if (winners[0].descr === "Pair, A's" || winners[0].descr === "Pair, K's" || winners[0].descr === "Pair, Q's") {
            //         return 0;
            //     }
            // }
            return currentBet;
        } else {
            let isPlayer = false;
            for (let i = 0; i < winners.length; i++) {
                if (winners[i].id === self.id) {
                    isPlayer = true;
                }
            }

            if (isPlayer) {
                if (GameConstants.HIGH_CARD.replace("_", " ") === winners[0].name.toLowerCase()) {
                    return game.call;
                } else if (GameConstants.PAIR.replace("_", " ") === winners[0].name.toLowerCase() || GameConstants.TWO_PAIR.replace("_", " ") === winners[0].name.toLowerCase()) {
                    return Math.max(game.call, game.bigBlind * (this.attributes.aggressiveness / 10) * (Math.random() * 3 - 1));
                } else {
                    return Math.max(game.call, game.bigBlind * (this.attributes.aggressiveness / 10) * (Math.random() * 6 - 1));
                }
            } else {

                if (playerHand.name === winners[0].name && game.state !== GameConstants.RIVER && GameConstants.HIGH_CARD.replace("_", " ") !== playerHand.name.toLowerCase() && GameConstants.PAIR.replace("_", " ") !== playerHand.name.toLowerCase()) {
                    return game.call;
                }
                return 0;
            }
        }

        return currentBet;
    }

    public finalizeActions(game: PokerGameState): void {

        for (let i = 0; i < game.players.length; i++) {

            let player = game.players[i];

            this.ACTIONS[player.id] = this.ACTIONS[player.id] || [];

            var actionObject: any = {};
            actionObject.community = this.getCommunityHandScore(game);
            actionObject.wagered = player.wagered;
            actionObject.payout = player.payout;
            actionObject.folded = player.state === GameConstants.INACTIVE;

            if (player.cards) {
                actionObject.pre = this.getPreFlopHandScore(player.cards);
                actionObject.post = this.getFlopHandScore(game.community, player.cards);
                actionObject.risk = actionObject.post - actionObject.community;

                actionObject.bet_pre = 0;

                if (player.actions[GameConstants.PRE_FLOP]) {
                    for (let j = 0; j < player.actions[GameConstants.PRE_FLOP].length; j++) {

                        let action = player.actions[GameConstants.PRE_FLOP][j];
                        if (action.type !== GameConstants.FOLD) {
                            actionObject.bet_pre += action.bet || 0;
                        }
                    }

                    if (actionObject.bet_pre > 50) {
                        actionObject.pre_ratio = actionObject.bet_pre / (actionObject.pre || 1);
                    }
                }

                actionObject.bet_post = actionObject.wagered - actionObject.bet_pre;
            }

            this.ACTIONS[player.id].push(actionObject);
        }
    }

    private getBetAfterAttributes(bet: number, game: PokerGameState, handsScore: number): { bet: number, bluff: boolean, handScore: number } {

        let self = this.self(game.players);
        let bluff = false;

        // AGRESIVIDAD: modificamos la cantidad apostada segun la agresividad (multiplicador .5 a 2)
        if (bet > 0) {
            if (this.attributes.aggressiveness < 50) {
                bet *= (.5 + (this.attributes.aggressiveness / 50) * .5);
            } else {
                bet *= (1 + (this.attributes.aggressiveness - 50) / 50);
            }
            bet = Math.round(bet);
        }

        // BLUFF: probabilidad de tirarse un farol con malas cartas
        if (Math.random() * 100 < this.attributes.bluff) {
            if (bet < this.call(game.players)) {
                bet = Math.max(this.call(game.players), Math.round(Math.random() * self.chips));
                bluff = true;
            }
        }

        // CALL: probabilidad de que se reduzca la apuesta a un call
        if (Math.random() * 100 < this.attributes.calls) {
            if (Math.abs(this.call(game.players) - bet) < self.chips / 10) {
                bet = this.call(game.players);
            }
        }

        // ALLIN: probabilidad de que se suba la apuesta a un all-in
        if (bet > 0) {
            if (Math.random() * 100 < this.attributes.allin) {
                if (bet > self.chips / 2) {
                    bet = self.chips;
                }
            }
        }

        // RANDOMNESS: probabilidad de hacer una jugada completamente aleatorea
        if (Math.random() * 100 < this.attributes.randomness) {
            bet = Math.round(Math.random() * self.chips);
        }

        return { bet: bet, bluff: bluff, handScore: handsScore };
    }

    private preFlopStrategy(game: PokerGameState) {

        let bet = 0;
        let self = this.self(game.players);
        let call = GameVars.gameState.call;
        let raise = GameVars.gameState.raise;

        if (this.isPair(self.cards)) {
            if (call < self.chips / 12) {
                bet = call;
            }
        }

        let handScore = this.getPreFlopHandScore(self.cards);
        let alreadyRaised = 0;

        // LEVEL: retocar el handScore segun el level del jugador
        handScore += this.levelRandom1;

        if (self.actions[GameConstants.PRE_FLOP] && self.actions[GameConstants.PRE_FLOP].length) {
            alreadyRaised += 1;
        }

        let dragging = false;
        if (handScore >= 90 && !alreadyRaised) {
            bet = 2 * this.CONFIDENT * this.getPotSize(game.players);
        } else if (handScore >= 70) {
            if (!alreadyRaised) {
                bet = this.CONFIDENT * this.getPotSize(game.players);
            } else {
                bet = call;
            }
        } else if (handScore >= 50) {
            if (!alreadyRaised && call < self.chips / 12) {
                bet = call;
            }
        }
        else {
            const p = game.players.find(q => q.self);
            if (p) {
                const credibility = ((100 - Number(RoomManager.getCredibility(p.id))) / 100) * 0.5;
                if (Math.random() < 0.5 + credibility) {
                    bet = call;
                }
            }
        }
        // else if (self.position >= game.players.length - 1 && !alreadyRaised) {
        //     // drag the limpers in if we are the button and the call is < threshold
        //     if (call < this.DRAG_THRESHOLD && call < self.chips / 12) {
        //         bet = call * 4;
        //         dragging = true;
        //     }
        // }

        if (this.attributes.level >= 9) {
            if (bet && call >= this.SHOVE_THRESHOLD && handScore < 90) {
                for (let i = 0; i < game.players.length; i++) {

                    let p = game.players[i];
                    let analysis = this.analyzePlayer(p);
                    if (analysis.actions > 20 && p.wagered >= 30) {
                        if (analysis.pre / analysis.actions > 5) {
                            let newbet = this.SHOVE_MITIGATION * this.getPotSize(game.players);

                            if (handScore > 70 && call < self.chips / 4) {
                                newbet = call;
                            }

                            bet = Math.min(newbet, bet);
                        }
                    }
                }
            }
        }

        return { bet: bet, bluff: false, handScore: handScore };
    }

    private postFlopStrategy(game: PokerGameState) {

        var bet = 0;
        var self = this.self(game.players);
        var call = GameVars.gameState.call;

        var preFlopScore = this.getPreFlopHandScore(self.cards);
        var handScore = this.getFlopHandScore(game.community, self.cards);
        var communityScore = this.getCommunityHandScore(game);

        // LEVEL: retocar el handScore segun el level del jugador 
        preFlopScore += this.levelRandom1;
        handScore += this.levelRandom2;
        communityScore += this.levelRandom3;

        var bluff = true;
        var bluffing = false;
        var realHandScore = handScore;
        var hasRaised = this.getPlayersThatRaised(game, game.state);
        if (this.bluffs[game.hand]) {
            if (bluff || this.bluffs[game.hand]) {
                if (!hasRaised.length) {
                    handScore = 100;
                }

                this.bluffs[game.hand] = true;
                bluffing = true;
            }
        }

        // need different betting strategies based on where we are in the game
        // for now:
        // 1) sound out other opponents hands
        // 2) go bigger
        if (handScore - communityScore >= this.CONFIDENT_THRESHOLD && handScore > 10) {
            bet = this.CONFIDENT * this.getPotSize(game.players);
        } else if (handScore - communityScore >= this.MIDDLING_THRESHOLD && handScore > 10) {
            bet = this.MIDDLING * this.getPotSize(game.players);
        } else if (realHandScore - communityScore >= this.PADDLING_THRESHOLD && handScore > 10) {
            bet = this.PADDLING * this.getPotSize(game.players);
        }

        if (this.attributes.level >= 9) {
            // use player analysis to guess when bots are playing a strong hand and fold if we are bluffing
            var mitigated = false;

            let keys = Object.keys(hasRaised);
            for (let i = 0; i < keys.length; i++) {
                let p = keys[i];
                if (mitigated) {
                    return this.getBetAfterAttributes(0, game, handScore);
                }
                var analysis = this.analyzePlayer(p);

                if (analysis.actions > 20) {

                    var shover = analysis.pre / analysis.actions > 5;
                    var folder = analysis.folds / analysis.actions > 2;
                    var srs = analysis.post / analysis.risk;
                    var luck_shot = analysis.luck / analysis.actions * 100 > this.LUCK_UPPER_THRESHOLD || analysis.luck / analysis.actions * 100 < this.LUCK_LOWER_THRESHOLD;

                    if (srs >= this.RISK_THRESHOLD) {
                        var newbet = this.RISK_MITIGATION * this.getPotSize(game.players);
                        mitigated = true;
                        bet = Math.min(newbet, bet);
                    } else if (luck_shot && shover) {
                        var newbet = this.LUCK_MITIGATION * this.getPotSize(game.players);
                        mitigated = true;
                        bet = Math.min(newbet, bet);
                    }

                    if (!folder && self.position <= 1 && preFlopScore < 70 && realHandScore - communityScore <= 30) {
                        var newbet = this.LUCK_MITIGATION * this.getPotSize(game.players);
                        mitigated = true;
                        bet = Math.min(bet, newbet);
                    }
                }
            }

            const p = game.players.find(q => q.self);
            if (p) {
                const credibility = ((100 - Number(RoomManager.getCredibility(p.id))) / 100) * 0.5;
                if (Math.random() < 0.5 + credibility) {
                    bet = call;
                }
            }

            // if (realHandScore - communityScore <= 30 && bet > this.SHOVE_THRESHOLD) {
            //     for (let i = 0; i < game.players.length; i++) {

            //         let p = game.players[i];
            //         if (mitigated) { return this.getBetAfterAttributes(0, game); }
            //         if (p.state !== GameConstants.ACTIVE) { continue; }
            //         var analysis = this.analyzePlayer(p);

            //         if (analysis.pre / analysis.actions > 5) {  // Likelyhood they have a good hand?
            //             if (call > self.chips / 8) {
            //                 var newbet = this.SHOVE_MITIGATION * this.getPotSize(game.players);
            //                 bet = Math.min(newbet, bet);
            //             }
            //         }
            //     }
            // }
        }

        return this.getBetAfterAttributes(bet, game, handScore);
    }

    private getPlayersThatRaised(game: PokerGameState, state: string): any {

        let raises = this.getPlayersThat(game, GameConstants.RAISE, state) || {};
        return raises;
    }

    private getPlayersThat(game: PokerGameState, that: string, state: string): any {

        var raises = {};
        var self = this.self(game.players);
        var players = game.players;

        for (let i = 0; i < players.length; i++) {

            let player = players[i];

            if (player.position === self.position || player.id === self.id) {
                continue;
            }

            var states = [GameConstants.PRE_FLOP, GameConstants.FLOP, GameConstants.TURN, GameConstants.RIVER];
            if (state) {
                states = [state];
            }

            for (let j = 0; j < states.length; j++) {
                var actions = player.actions[states[j]];
                if (actions) {
                    for (let k = 0; k < actions.length; k++) {
                        if (actions[k] && actions[k].type === that) {
                            raises[player.id] = raises[player.id] || 0;
                            raises[player.id] += 1;
                        }
                    }
                }
            }
        }

        return raises;
    }

    private self(players: PlayerState[]): PlayerState {

        for (let i = 0; i < players.length; i++) {
            if (players[i].id === this.id) {
                return players[i];
            }
        }
    }

    private call(players: PlayerState[]): number {

        let bet = 0;

        for (let i = 0; i < players.length; i++) {
            if (players[i].wagered > bet) {
                bet = players[i].wagered;
            }
        }

        return bet;
    }

    private isPair = function (hand: string[]) {
        return hand[0][0] === hand[1][0];
    };

    private sortCards(cards: any) {
        cards.sort(function (a: any, b: any) {
            return Bot.cardValue(a) - Bot.cardValue(b);
        });
    }

    private getPreFlopHandScore(hand: any): number {

        this.sortCards(hand);

        var is_pair = this.isPair(hand);
        var our_hand = hand[0][0] + hand[1][0];

        if (is_pair && "AK".match(hand[0][0])) { return Bot.AK_PAIR_PRE; }
        if (is_pair && "QJ".match(hand[0][0])) { return Bot.QJ_PAIR_PRE; }
        if (is_pair && "T".match(hand[0][0])) { return Bot.T_PAIR_PRE; }

        if ("KA" === our_hand) { return Bot.AK_CONN_PRE; }

        if (our_hand.match("T")) { return Bot.R_CONN_PRE; }
        if (our_hand.match("J")) { return Bot.R_CONN_PRE; }
        if (our_hand.match("Q")) { return Bot.R_CONN_PRE; }
        if (our_hand.match("K")) { return Bot.R_CONN_PRE; }
        if (our_hand.match("A")) { return Bot.R_CONN_PRE; }

        return 0;
    }

    private getFlopHandScore(community, cards): any {

        var handData = this.evaluateHand(community, cards);

        if (handData.straight > 0 || handData.flush > 0) {
            var communityData = this.evaluateHand(community, []);
            if (Math.abs(communityData.straight) >= 2 && Math.abs(communityData.flush) >= 2) {
                return Bot.HIGH_STRAIGHT_POST;
            }
        }

        if (handData.foak || handData.fullhouse > 0) {
            return Bot.FULLHOUSE_POST;
        }

        if (handData.straight > 0 || handData.flush > 0) {
            return Bot.FLUSH_POST;
        }

        if (handData.overpair || handData.setpair) {
            return Bot.OVERPAIR_POST;
        }

        if (handData.toppair) {
            return Bot.TOPPAIR_POST;
        }

        return 0;
    }

    private getPotSize = function (players: PlayerState[]): number {

        var pot = 0;
        for (let i = 0; i < players.length; i++) {
            pot += players[i].wagered + players[i].poted;
        }

        return pot;
    };

    private analyzePlayer(player: any) {

        var summary = {
            payout: 0,
            risk: 0,
            post: 0,
            pre: 0,
            luck: 0,
            actions: 0,
            folds: 0
        };

        var pname = "";

        if (typeof player === "string") {
            pname = player;
        } else {
            pname = player.id;
        }

        if (!this.ACTIONS[pname]) {
            return summary;
        }

        var last_analysis = this.LAST_ANALYSIS[pname] || summary;
        summary = last_analysis;

        for (var i = last_analysis.actions; i < this.ACTIONS[pname].length; i++) {

            var ainfo = this.ACTIONS[pname][i];
            summary.actions += 1;

            if (ainfo.payout) {
                summary.payout += ainfo.payout;

                if (ainfo.risk) {
                    summary.luck += (ainfo.payout / (ainfo.risk || 1));
                }
            }

            if (ainfo.folded) {
                summary.folds += 1;
            }

            if (ainfo.post) {
                summary.post += ainfo.post;
                summary.risk += ainfo.risk;
            }

            if (ainfo.pre_ratio) {
                summary.pre += ainfo.pre_ratio || 0;
            }
        }

        let keys = Object.keys(summary);
        for (let i = 0; i < keys.length; i++) {
            summary[keys[i]] = Math.round(summary[keys[i]] * 100) / 100;
        }

        this.LAST_ANALYSIS[pname] = summary;
        return summary;
    }

    private getCommunityHandScore(game: PokerGameState) {

        var self = this.self(game.players);

        var modifier = 0;
        var communityData = this.evaluateHand(game.community, []);
        var handData = this.evaluateHand(game.community, self.cards);

        switch (communityData.straight) {
            case 0:
            case 1:
                modifier += Bot.STRAIGHT_RISK;
                break;
            case -1:
            case -2:
                modifier += Bot.STRAIGHT_RISK - Bot.DRAW_RISK;
                break;
            default:
                break;
        }

        switch (communityData.flush) {
            case 0:
            case 1:
                modifier += Bot.FLUSH_RISK;
                break;
            case -1:
            case -2:
                modifier += Bot.FLUSH_RISK - Bot.DRAW_RISK;
                break;
            default:
                break;

        }

        switch (communityData.fullhouse) {
            case 0:
            case 1:
                modifier += Bot.FULLHOUSE_RISK;
                break;
            case -1:
            case -2:
                modifier += Bot.FULLHOUSE_RISK - Bot.DRAW_RISK;
                break;
            default:
                break;

        }

        if (!modifier) {
            if (communityData.pair) { modifier += Bot.PAIR_RISK; }
            if (communityData.toak) { modifier += Bot.PAIR_RISK; }
            if (communityData.foak) { modifier += Bot.PAIR_RISK; }

            if (Bot.cardValue(handData.highcard) <= 4 && !handData.topcard) { modifier += Bot.TOPCARD_RISK; }
            if (Bot.cardValue(handData.highcard) <= 6 && !handData.topcard) { modifier += Bot.TOPCARD_RISK; }
            if (Bot.cardValue(handData.highcard) <= 10 && !handData.topcard) { modifier += Bot.TOPCARD_RISK; }
        }

        if (handData.lowpair) {
            modifier += (Bot.LOWPAIR_RISK * handData.lowpair);
        }

        return modifier;

    }

    private evaluateHand(community, cards) {

        var fullHand = cards.concat(community);

        this.sortCards(community);
        this.sortCards(fullHand);

        var communityWorst = community[0];
        var communityBest = community[community.length - 1];

        var straight = this.isStraight(fullHand);
        var flush = this.isFlush(fullHand);
        var sameCards = this.countSame(fullHand);

        var pairs = 0;
        var triples = 0;
        var fours = 0;

        for (let i = 0; i < sameCards.length; i++) {
            if (sameCards[i].count === 2) { pairs++; }
            if (sameCards[i].count === 3) { triples++; }
            if (sameCards[i].count === 4) { fours++; }
        }

        var fullhouse_dist = -3;
        if (pairs) { fullhouse_dist = -2; }
        if (triples) { fullhouse_dist = -1; }
        if (pairs > 1) { fullhouse_dist = -1; }
        if (triples && pairs) { fullhouse_dist = 1; }

        var ret: any = {
            straight: straight,
            flush: flush,
            sameCards: sameCards,
            foak: fours > 0,
            toak: triples > 0,
            pair: pairs > 0,
            highcard: fullHand[fullHand.length - 1],
            lowcard: fullHand[0],
            lowpair: 0,
            topcard: false,
            botcard: false,
            fullhouse: fullhouse_dist > 0 ? 1 : fullhouse_dist
        };

        var ofakind = false;
        if (cards.length > 1) {
            // look for overpair
            if (communityBest) {
                if (this.isPair(cards)) {
                    if (Bot.cardValue(cards[0]) > Bot.cardValue(communityBest)) { ret.overpair = true; }

                    for (let i = 0; i < sameCards.length; i++) {
                        if (sameCards[i].value > Bot.cardValue(cards[0])) { ret.lowpair += 1; }
                    }

                    if (community.length < 5) { ret.lowpair += (0.5 * (5 - community.length)); }
                }

                if (Bot.cardValue(communityBest) === Bot.cardValue(cards[0]) ||
                    Bot.cardValue(communityBest) === Bot.cardValue(cards[1])) {
                    ret.toppair = true;
                }

                if (Bot.cardValue(communityBest) <= Bot.cardValue(cards[0]) || (Bot.cardValue(communityBest) <= Bot.cardValue(cards[1]))) {
                    ret.topcard = true;
                }
            }

            // set (pocket pair + card on board)
            if (this.isPair(cards)) {
                for (let i = 0; i < sameCards.length; i++) {
                    if (sameCards[i].value === Bot.cardValue(cards[0]) && sameCards[i].count > 2) {
                        ofakind = true;
                    }
                }

                if (ofakind) {
                    ret.setpair = true;
                }
            }
        }

        return ret;
    }

    private countSame(cards) {

        var cardCount = [];
        for (let i = 0; i < cards.length; i++) {
            var value = Bot.cardValue(cards[i]);
            cardCount[value] = (cardCount[value] || 0) + 1;
        }

        var result = [];
        cardCount.forEach(function (x, index) {
            if (x >= 1) {
                result.push({
                    value: index,
                    count: x
                });
            }
        });
        result.reverse();
        return result;
    }

    private isFlush(cards) {

        var suits = {};
        var flush = false;
        var maxcount = 0;

        for (let i = 0; i < cards.length; i++) {
            var suit = cards[i][1];
            suits[suit] = (suits[suit] || 0) + 1;

            if (suits[suit] >= 5) {
                flush = true;
            }

            maxcount = Math.max(maxcount, suits[suit]);
        }

        if (flush) {
            return 1;
        }

        return -(5 - maxcount);
    }

    private isStraight(cards) {

        var uniqueCards: any = {};
        for (let i = 0; i < cards.length; i++) {
            uniqueCards[Bot.cardValue(cards[i])] = 1;
            if (cards[i][0] === "A") { uniqueCards[1] = 1; }
        }

        uniqueCards = Object.keys(uniqueCards).map(function (c) { return parseInt(c, 10); });
        uniqueCards = uniqueCards.sort(function (a, b) { return a - b; });

        var dist = 7;
        for (var i = 0; i < uniqueCards.length; i++) {
            if (uniqueCards - i < 2) { continue; }
            var delta_2 = uniqueCards[i + 1] - uniqueCards[i];
            if (delta_2 <= 4) { dist = Math.min(dist, 3); }

            if (uniqueCards - i < 3) { continue; }
            var delta_3 = uniqueCards[i + 2] - uniqueCards[i];
            if (delta_3 <= 4) { dist = Math.min(dist, 2); }

            if (uniqueCards - i < 4) { continue; }
            var delta_4 = uniqueCards[i + 3] - uniqueCards[i];
            if (delta_4 <= 4) { dist = Math.min(dist, 1); }

            if (uniqueCards - i < 5) { continue; }
            var delta_5 = uniqueCards[i + 4] - uniqueCards[i];
            if (delta_5 <= 4) { dist = Math.min(dist, 0); }
        }

        if (dist === 0) { return 1; }
        return -dist;
    }
}
